// Only visit/dismissal preferences live here. Daily streak/completion is server truth.
export const VISIT_KEY = 'perfect-slice.reminder-visit.v1';
export const dismissalKey = scope => `perfect-slice.daily-reminder-dismissed.v1:${scope}`;
let visit;
const dismissed = new Map();
export function reminderVisit() {
  if (visit) return visit;
  const startedAt = Date.now();
  try {
    const previous = Number(localStorage.getItem(VISIT_KEY));
    // Existing players can be recognized before the new visit marker was added.
    let playedBefore = false;
    try { playedBefore = JSON.parse(localStorage.getItem('perfect-slice.records.v1') || '{}').shapesPlayed > 0; } catch { /* Malformed game cache isn't proof of a prior visit. */ }
    localStorage.setItem(VISIT_KEY, String(startedAt));
    visit = { returning: (previous > 0 && previous <= startedAt) || playedBefore, storageAvailable: true, startedAt };
  } catch { visit = { returning: false, storageAvailable: false, startedAt }; }
  return visit;
}
export function reminderDismissed(scope, day) {
  if (dismissed.get(scope) === day) return true;
  try { return localStorage.getItem(dismissalKey(scope)) === day; }
  catch { return true; /* Cannot persist once-per-day preference: don't interrupt. */ }
}
export function markReminderShown(scope, day) {
  dismissed.set(scope, day);
  try { localStorage.setItem(dismissalKey(scope), day); } catch { /* This document retains the once-per-day preference in memory. */ }
}
export const isReminderRoute = view => ['/', '/perfectslice', '/perfectslice/leaderboard', '/account'].includes(view);
